import { validationMixin } from "vuelidate";
import { required, email } from "vuelidate/lib/validators";

import EditInsuranceReqRCA from "@/views/Common/editInsuranceReqRCA.js";

export default {
    name: "InsuranceDetails",

    extends: EditInsuranceReqRCA,

    props: ["clickedNext", "currentStep"],

    mixins: [validationMixin],

    components: {},

    props: {},

    data: () => {
        return {};
    },
    created() {
        
        this.vehicleOptions.DirectSettlement = true;
        this.vehicleOptions.ValidityPeriod = [12];
    },

    computed: {},

    methods: {},

    mounted() {}
};
